import ModalHealthIndicators from "./ModalHealthIndicators";

export default ModalHealthIndicators;